export const environment = {
    production: false,
    version: '{BUILD_VERSION}',
    loadDataFromBE: true,
    backendURL:
        'https://phishing-container-backend.wittyglacier-57b8d47e.eastus.azurecontainerapps.io/api/v1/',
    backendWebsocketURL:
        'https://phishing-container-backend.wittyglacier-57b8d47e.eastus.azurecontainerapps.io/socket/connect',
};
